
import { concat } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import React from "react";
import { map, defaultArg } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { empty, map as map_1 } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { AssetIdentifier } from "../../Shared/Tool.js";
import { useAssignedTrackers } from "../../Requests/Telematics.js";

function identifierValue(tracker) {
    const matchValue = tracker.Status;
    let matchResult, status_1;
    if (matchValue != null) {
        if (matchValue.Imei !== "") {
            matchResult = 0;
            status_1 = matchValue;
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0:
            return concat(tracker.Name, " · ", ...status_1.Imei);
        default:
            return tracker.Name;
    }
}

export function TrackerIdentifiers(props) {
    return props.Render(defaultArg(map((page) => map_1((tracker) => (new AssetIdentifier(identifierValue(tracker), "tracker")), page.Trackers), useAssignedTrackers(props.EntityType, props.EntityId).data), empty()));
}

